/**
 * The service name to show: the one in her language, or the other language's
 * when that one was left empty. One name is enough (D-67).
 */
export function serviceName(ru: string, ky: string, locale: string): string {
  return locale === 'ky' ? ky || ru : ru || ky;
}
